"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var MobileMenu = /*#__PURE__*/function () {
  function MobileMenu() {
    _classCallCheck(this, MobileMenu);

    this._mobileIcon = $("#menuIcon");
    this._mobileMenu = $("#mobileMenu");
    this._dropDownOpenerIcon = $(".openDropDown");
    this._header = $("header");
    this.clickToMobileIcon();
    this.clickToDropdownIcon();
  }

  _createClass(MobileMenu, [{
    key: "clickToMobileIcon",
    value: function clickToMobileIcon() {
      var _this2 = this;

      this._mobileIcon.click(function (e) {
        _this2._headerHeight = _this2.getCurrentHeaderHeight();

        var _this = $(e.currentTarget);

        var isActive = _this.attr("data-active");

        _this2.setMobileMenuCSSTop(_this2._headerHeight);

        if (isActive === "true") {
          _this.attr("data-active", "false");

          _this2.enablePageScrolling();

          _this2._mobileMenu.slideUp(600);
        } else {
          _this.attr("data-active", "true");

          _this2.disablePageScrolling();

          _this2._mobileMenu.slideDown(600);
        }
      });
    }
  }, {
    key: "clickToDropdownIcon",
    value: function clickToDropdownIcon() {
      this._dropDownOpenerIcon.click(function (e) {
        var _this = $(e.currentTarget);

        var dropDownMenu = _this.parents("li").next("li");

        var isDropDownMenuActive = dropDownMenu.hasClass("active");

        if (isDropDownMenuActive) {
          dropDownMenu.removeClass("active");

          _this.removeClass("active");
        } else {
          dropDownMenu.addClass("active");

          _this.addClass("active");
        }

        dropDownMenu.slideToggle();
      });
    }
  }, {
    key: "setMobileMenuCSSTop",
    value: function setMobileMenuCSSTop(val) {
      this._mobileMenu.css("top", val);
    }
  }, {
    key: "getCurrentHeaderHeight",
    value: function getCurrentHeaderHeight() {
      return this._header.outerHeight();
    }
  }, {
    key: "disablePageScrolling",
    value: function disablePageScrolling() {
      $("html,body").addClass("stopScroll");
      $("html,body").on("touchmove", function (e) {
        e.preventDefault();
      });

      this._mobileMenu.on("touchmove", function (e) {
        return true;
      });
    }
  }, {
    key: "enablePageScrolling",
    value: function enablePageScrolling() {
      $("html,body").removeClass("stopScroll");
      $("html,body").on("touchmove", function (e) {
        return true;
      });
    }
  }]);

  return MobileMenu;
}();